export const changeTemperatureCropNameSelectedReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_TemperatureCropNameSelected":
      return action.payload.TemperatureCropNameSelected;
    default:
      return state;
  }
};
